import type { IDeviceInfo } from '@sravni/koa-utils/lib/middlewares/device';

import { isProdBuild } from './environment';
import { isServer } from './isServer';

interface IEvent {
  event: 'adEvent' | 'mainEvent' | 'pageViewGA' | 'frontendReady';
  title?: string;
  path?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  eventValue?: number;
  deviceType?: 'mobile' | 'desktop' | 'tablet';
  pixelOn?: boolean;
}

interface IEventSource extends Pick<IEvent, 'event' | 'eventValue' | 'title' | 'path' | 'deviceType' | 'pixelOn'> {
  eventCategory?: string | string[];
  eventAction?: string | string[];
  eventLabel?: string | string[];
}

interface IAnalyticsWindow extends Window {
  sravniDataLayer: IEvent[];
}

declare const window: IAnalyticsWindow;

const stringifyEventValue = (strings: undefined | string | string[]): string | undefined =>
  Array.isArray(strings) ? strings.join('|') : strings;

// Send data to Data Layer
export const pushGoogleEvent = (event: IEvent) => {
  if (!isServer) {
    if (isProdBuild) {
      // setup initial datalayer before add new event
      window.sravniDataLayer = window.sravniDataLayer || [];
      window.sravniDataLayer.push(event);
    } else {
      // tslint:disable-next-line:no-console
      console.log('pushEvent', event);
    }
  }
};

// Push events
export const pushEvent = (event: IEventSource) => {
  pushGoogleEvent({
    ...event,
    eventAction: stringifyEventValue(event.eventAction),
    eventLabel: stringifyEventValue(event.eventLabel),
    eventCategory: stringifyEventValue(event.eventCategory),
  });
};

export const sendSpaIsReadyEvent = (deviceInfo: IDeviceInfo) => {
  let device = 'desktop';
  if (deviceInfo.phone) {
    device = 'mobile';
  } else if (deviceInfo.tablet) {
    device = 'tablet';
  }

  pushEvent({
    event: 'frontendReady',
    deviceType: device as IEvent['deviceType'],
    pixelOn: true,
  });
};

export const makeMainGEvent = (event: Partial<IEventSource>): IEventSource => ({
  eventLabel: undefined,
  eventAction: undefined,
  eventValue: undefined,
  eventCategory: undefined,
  ...event,
  event: 'mainEvent',
});

export const makeAdGEvent = (event: Partial<IEventSource>): IEventSource => ({
  eventLabel: undefined,
  eventAction: undefined,
  eventValue: undefined,
  eventCategory: undefined,
  ...event,
  event: 'adEvent',
});
